// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let PageUITitle = require("../../../components/PageTitle/PageUITitle.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayHeader_draft_graphql = require("../../../__generated__/PropertyWizardRelayHeader_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayHeader_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayHeader_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayHeader_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayHeader_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayHeader_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Header(props) {
  let match = PropertyWizardFormRelay.Context.use();
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayHeader_draft_graphql.node, convertFragment, props.draft);
  let streetAddress = Stdlib_Option.getOr(draft.draftProperty.address, "your property");
  let tmp = match.mode;
  if (typeof tmp !== "object") {
    return JsxRuntime.jsx(PageUITitle.make, {
      title: "Broadcast your property to TAN members"
    });
  }
  switch (tmp.TAG) {
    case "Edit" :
      return JsxRuntime.jsx(PageUITitle.make, {
        title: "You are editing " + streetAddress
      });
    case "Rebroadcast" :
      return JsxRuntime.jsx(PageUITitle.make, {
        title: "Rebroadcast " + (streetAddress + " to TAN members")
      });
    case "BroadcastQuietSeller" :
      return JsxRuntime.jsx(PageUITitle.make, {
        title: "Broadcast " + (streetAddress + " to TAN members")
      });
  }
}

let make = PropertyWizardRelay__Header;

exports.DraftFragment = DraftFragment;
exports.make = make;
/* PageUITitle Not a pure module */
